import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
var newWindow2 = window as any;
newWindow2.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();


/**
 * Inits
 */

if (document.querySelector('.block') !== null) {
    import('./gsap').then(function (page) {
        page.initGSAP();
    });
}

if (document.body.contains(document.querySelector('.missing-people-page')) || document.body.contains(document.querySelector('.media-container'))) {
    import('./mixitup').then(function (page) {
        page.initMixitup();
    });
}

if (document.querySelector('[data-fancybox]') !== null) {
    import('./fancybox').then(function (page) {
        page.initFancyBox();
    });
}



if (document.querySelector('.regions-page')) {
    import('./region-map').then(function (page) {
        page.initRegionMap();
    });
}


if (document.querySelector('.timeline-container')) {
    import('./form-timeline').then(function (page) {
        page.initFormTimeline();
    });
}

/**
* Mobile Navigation
*/
const header = document.querySelector(".mobile-nav") as HTMLElement;
const navToggle = document.querySelector("#nav-toggle");
const navToggleOpen_content = document.querySelector("#nav-toggle-content-open") as HTMLElement;
const navToggleClosed_content = document.querySelector("#nav-toggle-content-closed") as HTMLElement;

navToggle.addEventListener("click", (e) => {
    document.body.classList.toggle("scroll--disabled");
    header.classList.toggle("__open");
    navToggle.classList.toggle("nav-toggle--active");

    if (navToggle.classList.contains("nav-toggle--active")) {
    navToggleOpen_content.style.display = "block";
    navToggleClosed_content.style.display = "none";
    } else {
    navToggleOpen_content.style.display = "none";
    navToggleClosed_content.style.display = "block";
    }
});

/**
 * Temporary Fix due to duplicate of option with the value of "uppsala".
 */
const missingPeoplePage = document.querySelector(".missing-people-page") as HTMLElement;
if (missingPeoplePage) {
    const regionSelector = document.getElementById('region-filter');

    // Loop through each option and remove the one with value ".region--uppsala"
    const options = regionSelector.getElementsByTagName('option');
    for (let i = 0; i < options.length; i++) {
        if (options[i].value === '.region--uppsala') {
            regionSelector.removeChild(options[i]);
            break;
        }
    }
}
    